export enum ENUM_TIPOS_DE_FUENTES_HIDRICAS {
    SUPERFICIAL = 1,
    SUBTERRANEA = 2,
}

export enum ENUM_ETAPAS_COSTOS {
    PREINVERSION = 1,
    INVERSION = 2,
    AOC = 3,
}

export enum ENUM_PASOS_MENU {
    IDENTIFICACION_PROYECTO = 1,
    DATOS_TECNICOS_PROYECTO = 2,
    SITUACION_SIN_PROYECTO = 3,
    PLAN_AGROPECUARIO = 4,
    DEMANDA_HIDRICA = 5,
    COSTOS = 6,
    RENTABILIDAD = 7,
    PROYECTO = 8,
    PRECIOS_MERCADO = 9,
    PRODUCCION_AGROPECUARIA = 10,
    PRECIOS_ECONOMICOS = 11,
    MANO_OBRA = 12,
    RESUMEN = 13,
    SENSIBILIDAD_PARAMETROS = 14,
    SENSIBILIDAD_INDICADORES = 15,
    PRODUCTOR = 16,
    PRODUCTOR_DATOS = 17,
    PRODUCTOR_FINCAS = 18,
    PRODUCTOR_INDICADORES = 19,
    INVERSIONISTA = 20,
    INVERSIONISTA_DATOS = 21,
    INVERSIONISTA_INDICADORES = 22,
}
export enum ENUM_ESTADO_PROYECTO {
    EN_PROCESO = 1,
    REGISTRADO = 2,
}
export enum ENUM_ESTADO_REGISTRO {
    ACTIVO = 'Activo',
    DESACTIVADO = 'Desactivado',
}

export enum ENUM_FLUJO_RENTABILIDAD {
    /** FLUJO DE FONDOS DEL PROYECTO DE ADT A PRECIOS DE MERCADO */
    FLUJO_PR_MDO = 1,
    /** FLUJO DE FONDOS DEL PROYECTO DE ADT A PRECIOS SOMBRA  */
    FLUJO_PR_SOMBRA = 2,
    /** Flujo PS Sensibilidad VP  */
    FLUJO_PS_SENSIBILIDAD_VP = 3,
    /** Flujo PS Sensibilidad CP  */
    FLUJO_PS_SENSIBILIDAD_CP = 4,
    /** Flujo PS Sensibilidad Obras - 1  */
    FLUJO_PS_SENSIBILIDAD_OBRAS_1 = 5,
    /** Flujo PS Sensibilidad Obras - 2  */
    FLUJO_PS_SENSIBILIDAD_OBRAS_2 = 6,
    /** Flujo PS Sensibilidad Obras - 3  */
    FLUJO_PS_SENSIBILIDAD_OBRAS_3 = 7,
}
